import { render, staticRenderFns } from "./SettingNotes.vue?vue&type=template&id=6b75585b&scoped=true"
import script from "./SettingNotes.vue?vue&type=script&lang=js"
export * from "./SettingNotes.vue?vue&type=script&lang=js"
import style0 from "./SettingNotes.vue?vue&type=style&index=0&id=6b75585b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b75585b",
  null
  
)

export default component.exports